import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { api } from '../../api/client';
export default function UsersTab({ me }) {
    const [users, setUsers] = useState(null);
    const [error, setError] = useState(null);
    const [showNew, setShowNew] = useState(false);
    async function refresh() {
        try {
            const { users } = await api.listUsers();
            setUsers(users);
        }
        catch (e) {
            setError(e?.message ?? 'Failed to load users');
        }
    }
    useEffect(() => { refresh(); }, []);
    async function changeRole(u, role) {
        if (!window.confirm(`Change ${u.email}'s role to ${role}?`))
            return;
        try {
            await api.patchUser(u.id, { role });
            refresh();
        }
        catch (e) {
            alert(e?.message ?? 'Failed');
        }
    }
    async function resetPassword(u) {
        const pass = window.prompt(`Set new password for ${u.email} (min 10 characters):`);
        if (!pass)
            return;
        try {
            await api.patchUser(u.id, { password: pass });
            alert('Password updated; their other sessions are invalidated.');
        }
        catch (e) {
            alert(e?.message ?? 'Failed');
        }
    }
    async function remove(u) {
        if (u.id === me.id)
            return alert("You can't delete your own account.");
        if (!window.confirm(`Delete ${u.email}? This cannot be undone.`))
            return;
        try {
            await api.deleteUser(u.id);
            refresh();
        }
        catch (e) {
            alert(e?.message ?? 'Failed');
        }
    }
    return (_jsxs("div", { className: "settings-tab", children: [_jsxs("div", { className: "tab-head", children: [_jsxs("div", { children: [_jsx("h2", { children: "Users" }), _jsx("p", { className: "muted small", children: "Owners can invite, change roles, reset passwords." })] }), _jsx("div", { className: "actions", children: _jsx("button", { onClick: () => setShowNew(true), children: "+ Invite user" }) })] }), error && _jsx("div", { className: "err small pad-y", children: error }), !users && _jsx("div", { className: "muted", children: "Loading\u2026" }), users && (_jsxs("table", { className: "data-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Email" }), _jsx("th", { children: "Name" }), _jsx("th", { children: "Role" }), _jsx("th", { children: "Last login" }), _jsx("th", { children: "Created" }), _jsx("th", {})] }) }), _jsx("tbody", { children: users.map((u) => (_jsxs("tr", { children: [_jsxs("td", { children: [u.email, u.id === me.id && _jsx("span", { className: "tag", style: { marginLeft: 8 }, children: "you" })] }), _jsx("td", { children: u.name || _jsx("span", { className: "muted", children: "\u2014" }) }), _jsx("td", { children: _jsx("select", { value: u.role, onChange: (e) => changeRole(u, e.target.value), children: ['owner', 'editor', 'viewer'].map((r) => _jsx("option", { value: r, children: r }, r)) }) }), _jsx("td", { className: "muted small", children: u.last_login_at ?? '—' }), _jsx("td", { className: "muted small", children: u.created_at }), _jsxs("td", { className: "row-actions-cell", children: [_jsx("button", { className: "ghost small", onClick: () => resetPassword(u), children: "Reset password" }), _jsx("button", { className: "ghost small danger", onClick: () => remove(u), disabled: u.id === me.id, children: "Delete" })] })] }, u.id))) })] })), showNew && _jsx(NewUserDialog, { onClose: () => setShowNew(false), onCreated: () => { setShowNew(false); refresh(); } })] }));
}
function NewUserDialog({ onClose, onCreated }) {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [role, setRole] = useState('editor');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    async function submit(e) {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            await api.createUser({ email, name, role, password });
            onCreated();
        }
        catch (err) {
            setError(err?.message ?? 'Failed');
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsx("div", { className: "modal-backdrop", onClick: (e) => { if (e.target === e.currentTarget && !busy)
            onClose(); }, children: _jsxs("form", { className: "modal small-modal", onSubmit: submit, children: [_jsxs("div", { className: "modal-head", children: [_jsx("div", { className: "modal-title", children: "Invite user" }), _jsx("button", { type: "button", className: "ghost", onClick: onClose, disabled: busy, children: "Close" })] }), _jsxs("div", { className: "modal-body padded", children: [_jsxs("label", { className: "field", children: [_jsx("span", { children: "Email" }), _jsx("input", { type: "email", autoFocus: true, value: email, onChange: (e) => setEmail(e.target.value), required: true })] }), _jsxs("label", { className: "field", children: [_jsx("span", { children: "Name (optional)" }), _jsx("input", { type: "text", value: name, onChange: (e) => setName(e.target.value) })] }), _jsxs("label", { className: "field", children: [_jsx("span", { children: "Role" }), _jsxs("select", { value: role, onChange: (e) => setRole(e.target.value), children: [_jsx("option", { value: "owner", children: "owner" }), _jsx("option", { value: "editor", children: "editor" }), _jsx("option", { value: "viewer", children: "viewer" })] })] }), _jsxs("label", { className: "field", children: [_jsx("span", { children: "Initial password (min 10 chars \u2014 share with the user)" }), _jsx("input", { type: "text", value: password, onChange: (e) => setPassword(e.target.value), minLength: 10, required: true })] }), error && _jsx("div", { className: "err small", children: error })] }), _jsxs("div", { className: "modal-foot", children: [_jsx("span", { className: "muted small", children: "They can change their password later via \"Reset\"." }), _jsxs("div", { className: "actions", children: [_jsx("button", { type: "button", className: "ghost", onClick: onClose, disabled: busy, children: "Cancel" }), _jsx("button", { type: "submit", disabled: busy, children: "Create" })] })] })] }) }));
}
